import React, { Component } from 'react';
import { bannerService } from '../_services';
import { config } from '../_helpers';

function getDomPurifyFromWindow() {
    try {
        if (typeof window !== 'undefined' && window.DOMPurify && typeof window.DOMPurify.sanitize === 'function') {
            return window.DOMPurify;
        }
    } catch (err) {
        console.warn('Banner: failed to read window.DOMPurify', err);
    }
    return null;
}

function sanitizeHtml(html) {
    if (typeof html !== 'string' || html.length === 0) {
        return null;
    }
    try {
        const DOMPurify = getDomPurifyFromWindow();
        if (DOMPurify && typeof DOMPurify.sanitize === 'function') {
            const clean = DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
            return typeof clean === 'string' ? clean : null;
        }
    } catch (err) {
        console.warn('Banner: sanitiser failed', err);
    }
    return null;
}

class Banner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            banner: null,
            loaded: false
        };
        this._mounted = false;
        this._intervalId = null;
        this.refresh = this.refresh.bind(this);
    }

    componentDidMount() {
        this._mounted = true;
        this.refresh();

        try {
            const propInterval = this.props && this.props.pollIntervalMs;
            const configured = (typeof propInterval === 'number' && propInterval > 0)
                ? propInterval
                : (config && config.bannerPollMs) || (5 * 60 * 1000);
            if (configured > 0 && typeof window !== 'undefined' && window.setInterval) {
                this._intervalId = window.setInterval(this.refresh, configured);
            }
        } catch (err) {
            console.warn('Banner: failed to schedule refresh', err);
        }
    }

    componentWillUnmount() {
        this._mounted = false;
        if (this._intervalId !== null) {
            try {
                window.clearInterval(this._intervalId);
            } catch (e) {
                // ignore
            }
            this._intervalId = null;
        }
    }

    refresh() {
        try {
            bannerService.getActive()
                .then((banner) => {
                    if (!this._mounted) {
                        return;
                    }
                    try {
                        this.setState({ banner: banner || null, loaded: true });
                    } catch (err) {
                        console.warn('Banner: setState failed', err);
                    }
                })
                .catch((err) => {
                    // bannerService is non-throwing, but guard anyway.
                    console.warn('Banner: refresh promise rejected', err);
                    if (this._mounted) {
                        try {
                            this.setState({ banner: null, loaded: true });
                        } catch (e) {
                            // ignore
                        }
                    }
                });
        } catch (err) {
            console.warn('Banner: refresh failed', err);
            if (this._mounted) {
                try {
                    this.setState({ banner: null, loaded: true });
                } catch (e) {
                    // ignore
                }
            }
        }
    }

    renderHtmlOrText(value) {
        const sanitised = sanitizeHtml(value);
        if (sanitised !== null) {
            // Safe HTML — inject through dangerouslySetInnerHTML.
            return <div dangerouslySetInnerHTML={{ __html: sanitised }} />;
        }
        // Fallback: render as plain text. React escapes child strings, so this
        // is XSS-safe even when the raw value contains HTML.
        return <div>{value}</div>;
    }

    render() {
        try {
            const { banner, loaded } = this.state;
            // Render nothing while the first request is in flight or when the
            // backend says there is no active banner — no empty box, no border,
            // no layout shift.
            if (!loaded || !banner) {
                return null;
            }
            const header = typeof banner.header === 'string' ? banner.header.trim() : '';
            const footer = typeof banner.footer === 'string' ? banner.footer.trim() : '';
            if (!header && !footer) {
                return null;
            }
            return (
                <div className="row klo-active-banner">
                    <div
                        className="col"
                        style={{
                            padding: 10,
                            backgroundColor: 'rgb(0, 88, 161)',
                            color: 'white',
                            marginLeft: 15,
                            marginBottom: 1
                        }}
                    >
                        {header ? this.renderHtmlOrText(header) : null}
                        {footer ? this.renderHtmlOrText(footer) : null}
                    </div>
                </div>
            );
        } catch (err) {
            // Defence in depth — render path must never crash the page.
            console.error('Banner: render failed', err);
            return null;
        }
    }
}

export default Banner;




// WEBPACK FOOTER //
// ./src/components/Banner.jsx